import { get } from "lodash";

export const DEFAULT_GET_API_HEADER = (session_jwt: string) => {
  return {
    Authorization: `Bearer ${session_jwt}`,
  };
};
export const DEFAULT_POST_API_HEADER = (session_jwt: string) => {
  return {
    Authorization: `Bearer ${session_jwt}`,
    "Content-Type": "application/json",
  };
};

export const DEFAULT_FORM_DATA_HEADER = (session_jwt: string) => {
  return {
    Authorization: `Bearer ${session_jwt}`,
  };
};

//export const API_BASE_URL = "https://heal-be.onrender.com";
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL_LOCAL ||
  process.env.REACT_APP_API_BASE_URL;
export const WISH_AUTH_SERVICE_URL =
  process.env.REACT_APP_API_BASE_URL_LOCAL ||
  process.env.REACT_APP_API_BASE_URL;
export const WISH_INVOICE_SERVICE_URL =
  process.env.REACT_APP_WISH_INVOICE_SERVICE_URL;

export const API_ROUTES = {
  AUTHENTICATION: {
    base: "/authentication",
    login: "/signin",
    register: "/user/Add",
    resetPassword: "/resetPassword",
    changePassword: "/changePassword",
    updatePassword: "/updatePassword",
    getUserRoles: "/user/role",
  },
  APPOINTMENTS: {
    base: "/appointments",
    practitioner: "/practitioner",
    patient: "/patient",
    clinic: "/clinic",
    bookings: "/bookings",
    updateBookings: "/bookings/update",
    busyBooking: "/appointments/bookings/busy",
    getBookingDetails: "/appointments/bookings/{{BOOKING_ID}}",
    getBookingStateDetails: "/appointments/bookings/{{BOOKING_ID}}/state",
    cancelAppointment: "/appointments/bookings/{{BOOKING_ID}}",
    byPractitioner: "/appointments/practitioner/{{PRACTITIONER_ID}}",
    byClinic: "/appointments/practitioner/clinic/{{CLINIC_ID}}",
    byPatient: (patientId: string) => `/appointments/patient/${patientId}`,
    byPatientsessionbookings: (patientId: string) => `/sessionbookings/patient/${patientId}`,
    AllPatientsessionbookings: () => `/sessionbookings/`,
    UpdatePatientsessionbookingStatus: () => 
      `/sessionbookings/status`,
    byPractitionerWithDetails: (practitionerId: string) =>
      `/appointments/practitioner/${practitionerId}/details`,
    allBookingsbyPractitioner: (practitionerId: string) =>
      `/appointments/practitioner/${practitionerId}/details/all`,
    allSessionBookingsbyClinic: (clinicId: string) =>
      `/sessionbookings/clinic/${clinicId}/all`,
  },
  CLINIC_USER: {
    getUserByRole: "/user/roles",
    addUser: "/user/Add",
    updateUser: "/user/update",
  },
  CLINICS: {
    base: "/clinics",
    all: "/clinics/all",
    //getCalenderDetails: "/calenders",
    income: (clinicId: string) => `/clinics/${clinicId}/income`,
  },
  THERAPIES: {
    base: "/therapies",
    sessionEnabled: "/therapies/session-enabled",
  },
  PACKAGES: {
    base: "/packages",
    byId: (packageId: string) => `/packages/${packageId}`,
    buy: "/packages/:packageId/buy",
  },
  MEMBERSHIPPACKAGES: {
    base: "/membershippackages",
    byId: (membershipPackageId: string) => `/membershippackages/${membershipPackageId}`,
    buy: "/membershippackages/:membershipPackageId/buy",
    updatePatientsessionbookingStatus: "/membershippackages/status",
  },
  SESSION_BOOKING: {
    base: "/sessionbookings",
    getSession: "/sessionbookings/{{SESSION_ID}}/session",
    updateSession: "/sessionbookings/{{SESSION_ID}}/session",
  },
  CLINIC_CALENDAR: {
    base: "/calenders",
    //updateCalendar: "/calenders",
  },
  PRACTITIONERS: {
    base: "/practitioners",
    activePractitioners: "/practitioners/active",
    highlights: "/practitioners/{{PRACTITIONER_ID}}/highlights/",
    approve: "/practitioners/{{PRACTITIONER_ID}}/approve",
    reject: "/practitioners/{{PRACTITIONER_ID}}/reject",
    invite: "/practitioners/invite",
    therapies: "/practitioners/{{PRACTITIONER_ID}}/therapies",
    therapy: "/practitioners/{{PRACTITIONER_ID}}/therapies/{{THERAPY_ID}}",
    subscriptions: "/practitioners/{{PRACTITIONER_ID}}/subscriptions",
    subscriptionswithpastdates: "/practitioners/{{PRACTITIONER_ID}}/subscriptionswithpastdates",
    practitionerSubscriptionSuccess:
      "/practitioners/{{PRACTITIONER_ID}}/checkout/{{TRANSACTION_ID}}/success",
    getCheckoutSession: "/practitioners/checkout/{{TRANSACTION_ID}}",
    waiveOffPractitionerSubscription:
      "/practitioners/checkout/{{TRANSACTION_ID}}/discount",
    cancelPractitionerSubscription: (transactionId: string) =>
      `/practitioners/checkout/${transactionId}/cancel`,
    disablePractitioner: (practitionerId:string)=> `/practitioners/${practitionerId}/disable`,
    deletePractitioner: (practitionerId:string)=> `/practitioners/${practitionerId}`
  },
  SUBSCRIPTIONS: {
    base: "/subscriptions",
    checkout: (practitionerId: string) =>
      `/practitioners/${practitionerId}/checkout`,
    successfulPayment: "/success",
  },
  CHECKOUT_SESSION: {
    base: "/subscription/checkout",
  },
  PATIENT: {
    signup: "/patients/signup",
    patientBuyPackageSuccess: "/patients/{{PATIENT_ID}}/checkout/{{TRANSACTION_ID}}/success",
    getPatientCredits: "/patients/{{PATIENT_ID}}/credits",
    getPatientCreditsList: "/patients/{{PATIENT_ID}}/creditslist",
    bookSession: "/patients/{{PATIENT_ID}}/book-session",
    patientBuyBookingSessionSuccess: "/patients/{{PATIENT_ID}}/checkoutsession/{{TRANSACTION_ID}}/success",
    patientBuyMembershipPackageSuccess: "/patients/{{PATIENT_ID}}/checkoutmembershippackage/{{TRANSACTION_ID}}/success",
    getPatientMembershipPackageList: "/patients/{{PATIENT_ID}}/buymembershippackages",
    getPatientDetails: "/patients/{{PATIENT_ID}}",
    fetchConsentForm: "/patients/{{PATIENT_ID}}/consent-form",
    revokeConsentForm: "/patients/{{PATIENT_ID}}/consent-form/revoke",
    updateNotes: "/patients/{{PATIENT_ID}}/notes",
    profile: "/patients/{{PATIENT_ID}}/profile",
    enableDisable: "/patients/{{PATIENT_ID}}/disabled",
    deletePatient: "/patients/{{PATIENT_ID}}/delete",
    addCredits: "/patients/{{PATIENT_ID}}/addcredits",
    // Removed checkout endpoints since we're doing direct booking
    base: "/patients",
  },
  DOCUMENTS: {
    base: "/documents",
  },
  DASHBOARD: {
    base: "/dashboard",
    admin: "/administrator",
  },
  ANALYTICS: {
    base: "/analytics",
    clinics: "/clinics",
    practitioners: "/practitioners",
    therapies: "/therapies",
    all: "/all",
    allClinicsOccupancy: () => "/analytics/clinics/graph/occupancy/all",
    clinicsPractitionerRetentionRate: (clinicId: string) =>
      `/analytics/clinics/${clinicId}/graph/practitioners/retention-rate`,
    clinicsBookingsGraphData: (clinicId: string) =>
      `/analytics/clinics/${clinicId}/graph/bookings`,
    clinicsRevenueGraphData: (clinicId: string) =>
      `/analytics/clinics/${clinicId}/graph/revenue`,
    clinicsSubscriptionsGraphData: (clinicId: string) =>
      `/analytics/clinics/${clinicId}/graph/subscriptions`,
    clinicsOccupancyGraphData: (clinicId: string) =>
      `/analytics/clinics/${clinicId}/graph/occupancy`,
    clinicsRoomRevenueGraphData: (clinicId: string) =>
      `/analytics/clinics/${clinicId}/graph/room/revenue`,
    clinicsPractitionersRevenueGraphData: (clinicId: string) =>
      `/analytics/clinics/${clinicId}/graph/practitioners/revenue`,
    filterPractitioners: "/analytics/practitioners/filter",

    PRACTITIONER: {
      practitionerAppointments: (practitionerId: string) =>
        `/analytics/practitioner/${practitionerId}/appointments`,
      practitionerClinics: (practitionerId: string) =>
        `/analytics/practitioner/${practitionerId}/clinics`,
      practitionerSubscriptions: (practitionerId: string) =>
        `/analytics/practitioner/${practitionerId}/subscriptions`,
      practitionerEarnings: (practitionerId: string) =>
        `/analytics/practitioner/${practitionerId}/earnings`,
    },
  },
  DOC_LINK: {
    base: "/doclink",
  },
  ROOM_RESERVATIONS: {
    byClinicAndDate: "/practitioners/reservations/{{CLINIC_ID}}/{{SHORT_DATE}}",
    byPractitionerId: "/practitioners/{{PRACTITIONER_ID}}/reservations",
    byPractitionerAndClinic:
      "/practitioners/{{PRACTITIONER_ID}}/reservations/{{CLINIC_ID}}",
    byPractitionerSubscription: (practitionerSubscriptionId: string) =>
      `/rooms/subscriptions/${practitionerSubscriptionId}`,
    updateReservation: "/practitioners/reservations/update",
    deleteReservation: (reservationId:string)=>`/room-reservation/${reservationId}/delete`
  },

  ROOMS: {
    getRooms: "/rooms/clinic/{{CLINIC_ID}}",
    addRoom: "/rooms/clinic/{{CLINIC_ID}}/add",
    getRoomById: "/rooms/{{ROOM_ID}}",
    updateRoom: "/rooms/{{ROOM_ID}}/update",
    deleteRoom: "/rooms/{{ROOM_ID}}/delete",
  },
  PRACTITIONER_ROOM_BOOKINGS: {
    getPractitionerRoomBookings:
      "/practitioners/{{PRACTITIONER_ID}}/clinic/{{CLINIC_ID}}/bookings",
  },
  PRACTITIONER_SUBSCRIPTIONS: {
    byClinic: (clinicId: string) =>
      `/practitioners/subscriptions/byClinic/${clinicId}`,
    byClinicAndRoom: (clinicId: string, roomId: string) =>
      `/practitioners/subscriptions/byClinicAndRoom/${clinicId}/${roomId}`,
    all: `/practitioners/subscriptions/all`,
    updateDates: (subscriptionId:string) => `/practitioners/subscriptions/${subscriptionId}/dates`
  },
  CONSENT_FORM: {
    submit: "/patients/consent-form/submit",
  },
};
